"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "reigns", {
    enumerable: true,
    get: function() {
        return reigns;
    }
});
const _aewreigns = require("./aew.reigns");
const _womensworldreigns = /*#__PURE__*/ _interop_require_default(require("./womens-world.reigns"));
const _wwewomensreigns = /*#__PURE__*/ _interop_require_default(require("./wwe-womens.reigns"));
const _universalreigns = /*#__PURE__*/ _interop_require_default(require("./universal.reigns"));
const _wweChampreigns = /*#__PURE__*/ _interop_require_default(require("./wweChamp.reigns"));
const _nxtMensreigns = /*#__PURE__*/ _interop_require_default(require("./nxtMens.reigns"));
const _icreigns = /*#__PURE__*/ _interop_require_default(require("./ic.reigns"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const reigns = [
    ..._aewreigns.mens,
    ..._aewreigns.womens,
    ..._aewreigns.tnt,
    ..._universalreigns.default,
    ..._wweChampreigns.default,
    ..._nxtMensreigns.default,
    ..._icreigns.default,
    // tag
    {
        id: "8sdfsd",
        name: "Usos",
        wrestlerIds: [
            "jimmy-uso",
            "jey-uso"
        ],
        championshipId: "smackdown-tag",
        defenses: 8,
        startDate: new Date("July 18, 2021"),
        endDate: new Date("Apr 1, 2023")
    },
    {
        id: "uso8sfsds",
        name: "Usos",
        wrestlerIds: [
            "jimmy-uso",
            "jey-uso"
        ],
        championshipId: "raw-tag",
        startDate: new Date("July 18, 2021"),
        endDate: new Date("Apr 1, 2023")
    },
    {
        id: "j7sd7vd",
        wrestlerIds: [
            "damian-priest",
            "finn-balor"
        ],
        championshipId: "smackdown-tag",
        startDate: new Date("October 16, 2023"),
        endDate: new Date("Apr 15, 2024")
    },
    {
        id: "j123dfsbbb",
        wrestlerIds: [
            "damian-priest",
            "finn-balor"
        ],
        championshipId: "smackdown-tag",
        startDate: new Date("Sept 02, 2023"),
        endDate: new Date("October 7, 2023")
    },
    {
        id: "2222sdfsdf",
        wrestlerIds: [
            "damian-priest",
            "finn-balor"
        ],
        championshipId: "raw-tag",
        startDate: new Date("October 16, 2023"),
        endDate: new Date("Apr 15, 2024")
    },
    {
        id: "jsadjistzzzz",
        wrestlerIds: [
            "damian-priest",
            "finn-balor"
        ],
        championshipId: "raw-tag",
        startDate: new Date("Sep 02, 2023"),
        endDate: new Date("October 7, 2023")
    },
    {
        id: "jdfsgy91",
        wrestlerIds: [
            "kevin-owens",
            "sami-zayn"
        ],
        championshipId: "smackdown-tag",
        startDate: new Date("Apr 02, 2023"),
        endDate: new Date("Sept 2, 2023")
    },
    {
        id: "5875fd1",
        wrestlerIds: [
            "kevin-owens",
            "sami-zayn"
        ],
        championshipId: "raw-tag",
        startDate: new Date("Apr 02, 2023"),
        endDate: new Date("Sept 9, 2023")
    },
    // world womens
    ..._wwewomensreigns.default,
    ..._womensworldreigns.default,
    // mitb
    {
        id: "mitb-story",
        name: "Money in the Bank",
        image: "//www.wwe.com/f/styles/wwe_large/public/all/2022/07/20220702_MITB_main--c3e7a8a1b3f5c7e0e8b3d0b9b0c6d1d6.jpg",
        wrestlerIds: [
            "damian-priest"
        ],
        championshipId: "mitb",
        startDate: new Date("July 1, 2023"),
        endDate: new Date("Apr 15, 2024")
    },
    // us
    {
        id: "us-01",
        wrestlerIds: [
            "logan-paul"
        ],
        championshipId: "us",
        startDate: new Date("Nov 4, 2023")
    },
    {
        id: "us-02",
        wrestlerIds: [
            "rey-mysterio"
        ],
        championshipId: "us",
        startDate: new Date("Aug 11, 2023"),
        endDate: new Date("Nov 4, 2023")
    },
    {
        id: "us-03",
        wrestlerIds: [
            "austin-theory"
        ],
        championshipId: "us",
        startDate: new Date("Nov 26, 2022"),
        endDate: new Date("Aug 11, 2023")
    },
    {
        id: "us-04",
        wrestlerIds: [
            "seth-rollins"
        ],
        championshipId: "us",
        startDate: new Date("Oct 10, 2022"),
        endDate: new Date("Nov 26, 2022")
    },
    {
        id: "us-05",
        wrestlerIds: [
            "bobby-lashley"
        ],
        championshipId: "us",
        startDate: new Date("Jul 2, 2022"),
        endDate: new Date("Oct 10, 2022")
    },
    {
        id: "us-06",
        wrestlerIds: [
            "austin-theory"
        ],
        championshipId: "us",
        startDate: new Date("APR 18, 2022"),
        endDate: new Date("JUL 2, 2022")
    },
    {
        id: "us-07",
        wrestlerIds: [
            "finn-balor"
        ],
        championshipId: "us",
        startDate: new Date("FEB 28, 2022"),
        endDate: new Date("APR 18, 2022")
    },
    {
        id: "us-08",
        wrestlerIds: [
            "damian-priest"
        ],
        championshipId: "us",
        startDate: new Date("AUG 21, 2021"),
        endDate: new Date("FEB 28, 2022")
    },
    {
        id: "us-09",
        wrestlerIds: [
            "sheamus"
        ],
        championshipId: "us",
        startDate: new Date("APR 11, 2021"),
        endDate: new Date("AUG 21, 2021")
    },
    {
        id: "us-10",
        wrestlerIds: [
            "bobby-lashley"
        ],
        championshipId: "us",
        startDate: new Date("Aug 30, 2020"),
        endDate: new Date("Feb 21, 2021")
    },
    // mens world
    {
        id: "men-world-01",
        wrestlerIds: [
            "seth-rollins"
        ],
        championshipId: "world-heavyweight",
        startDate: new Date("May 27, 2023"),
        endDate: new Date("Apr 7, 2024")
    },
    {
        id: "men-world-02",
        wrestlerIds: [
            "drew-mcintyre"
        ],
        championshipId: "world-heavyweight",
        startDate: new Date("Apr 7, 2024"),
        endDate: new Date("Apr 7, 2024")
    },
    {
        id: "men-world-03",
        wrestlerIds: [
            "damian-priest"
        ],
        championshipId: "world-heavyweight",
        startDate: new Date("Apr 7, 2024")
    }
];
